class SEOEvents {
    constructor(devMode) {
      this.devMode = devMode || false;
    }

    // отправляем события из кук
    sendDeferred(){
        let self = this;
        const actions = {
            'seo_registered': (value) => self.registered(value),
            'seo_sign_in': (_) => self.sendEvent('signin'),
            'seo_buy_phone': (value) => self.buyPhone(value),
            'seo_tariff': (value) => self.changeTraiff(value),
            'seo_auto_renew': (_) => self.sendEvent('unsubscribe'),
            'seo_wizard': (value) => self.wizard(value)
        };

        this.userCookies().forEach((pair) => {
            let executingAction = pair[0].trim();
            let handler = actions[executingAction];
            if (handler) {
                handler(pair[1], executingAction);
            }
        });
    }

    deleteCookie(name) {
        if (!name) return;
        if (this.devMode) {
            console.log('delete cookie', name);
        }

        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    userCookies() {
        return document.cookie.split(';').map(
            (element) => element.split('=')
        );
    }

    wizard(step) {
        this.sendEvent(`wizard-step-${step}`);
    }

    changeTraiff(options) {
        this.sendEvent(
            'change',
            {'plan': this.prepareServiceValue(options)}
        );
    }

    buyPhone(options) {
        this.sendEvent(
            'subscribe',
            {'plan': this.prepareServiceValue(options)}
        );
    }

    prepareServiceValue(options) {
        if (options) {
            options = decodeURIComponent(options);
        }

        return 't1' + (options ? `|${options}` : '');
    }

    registered(socialName) {
        this.sendEvent(
            'signup',
            {'signup-type': socialName}
            );
    }

    determineCookieByEvent(eventName) {
        let actionName = {
            signin: 'seo_sign_in',
            unsubscribe: 'seo_auto_renew',
            signup: 'seo_registered',
            subscribe: 'seo_buy_phone',
            change: 'seo_tariff'
        }[eventName];

        if (!actionName && eventName.indexOf('wizard-step-') === 0) {
            actionName = 'seo_wizard';
        }

        return actionName;
    }

    sendEvent(eventName, options){
        const self = this;
        const actionName = self.determineCookieByEvent(eventName);

        let eventArgs = {'event': eventName};
        if (options) {
            eventArgs = {...eventArgs, ...options};
        }
        eventArgs.eventCallback = function() {
            self.deleteCookie(actionName);
        };
        if (this.devMode) {
            console.warn('Sending SEO GA Event', eventArgs);
            eventArgs.eventCallback();
            return;
        }

        try {
            console.warn('GA Event', eventArgs);
            dataLayer.push(eventArgs);
        } catch (e) {
            console.error(e);
        }
    }
}

export default SEOEvents;